import LifeMapNode from '../../GraphTypes/lifeMap/nodes/LifeMapNode'
import HexagonNode from '../../GraphTypes/lifeMap/nodes/HexagonNode'
import CircleNode from './CircleNode'
import RoundedRectangleNode from './RoundedRectangleNode'
import { withNodeDefaults } from './withNodeDefaults'

export const nodeTypes = {
  circle: {
    component: withNodeDefaults(CircleNode),
    label: 'Circle'
  },
  roundedRectangle: {
    component: withNodeDefaults(RoundedRectangleNode),
    label: 'Rounded Rectangle'
  },
  hexagon: {
    component: withNodeDefaults(HexagonNode),
    label: 'Hexagon'
  },
  lifeMapSlot: {
    component: withNodeDefaults(LifeMapNode),
    label: 'Life Map Item'
  }
}
